import { SimpleGrid, useMediaQuery } from '@chakra-ui/react'

import type { User } from '@core/app/types/contactsApiType'

import UserCard from './UseCard/UserCard'

interface UserListProps {
    users: User[]
}

export function useDesktopMediaQuery() {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    return isDesktop
}

const UserList = ({ users }: UserListProps) => {
    const isDesktop = useDesktopMediaQuery()
    return (
        <SimpleGrid columns={[2, 3]} spacing={isDesktop ? 10 : 4}>
            {users.map((user) => (
                <UserCard key={user.userId} user={user} />
            ))}
        </SimpleGrid>
    )
}

export default UserList
